module.exports = "/_next/static/images/28729f4b9448a081c209994acd474e66-blog2-lg.png";